import { render, staticRenderFns } from "./PressReleaseOverview.vue?vue&type=template&id=28e07ef6&scoped=true&"
import script from "./PressReleaseOverview.vue?vue&type=script&lang=js&"
export * from "./PressReleaseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e07ef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VExpansionPanels,VPagination})
